<template>
  <div id="GjwListPage" class="gjw-list-page">
    <gjw-list-page-layout>
      <template v-if="$slots.topBox" #topBox>
        <slot name="topBox" />
      </template>
      <template v-if="$slots.leftBox" #leftBox>
        <slot name="leftBox" />
      </template>
      <template #searchBox>
        <slot name="searchBox">
          <gjw-search-form ref="gjwSearchForm" v-bind="searchFormProps" v-on="$listeners" />
        </slot>
      </template>
      <template #btnBox>
        <slot name="btnBox">
          <div class="left-buttons">
            <template v-for="(sBtn, index) in singleButtons">
              <el-tooltip v-if="sBtn.showTooltip" :key="index" :content="sBtn.tooltipContent" placement="top" effect="dark">
                <el-button :type="sBtn.type" :plain="sBtn.plain" :icon="sBtn.icon" @click="sBtn.clickCb">{{ sBtn.text }}</el-button>
              </el-tooltip>
              <el-button v-else :key="index" :type="sBtn.type" :plain="sBtn.plain" :icon="sBtn.icon" @click="sBtn.clickCb">{{ sBtn.text }}</el-button>
            </template>
            <el-button-group v-if="selectList.length" class="group-btns">
              <el-button
                v-for="(gBtn, index) in groupButtons"
                :key="index"
                plain
                :disabled="gBtn.isDisabled && gBtn.isDisabled(selectList)"
                @click="gBtn.clickCb"
              >{{ gBtn.text }}</el-button>
            </el-button-group>
          </div>
          <div>
            <span>共 {{ dataTotal }} 条数据</span>
            <el-button
              v-if="showRefreshIcon"
              type="text"
              icon="el-icon-refresh-right"
              title="刷新"
              class="refresh-btn"
              @click="handleRefreshList"
            />
          </div>
        </slot>
      </template>
      <template #tableBox>
        <slot name="tableBox">
          <gjw-table
            ref="gjwTable"
            v-bind="tableProps"
            v-on="$listeners"
            @list-change="handleListChange"
            @table-selection-change="handleSelectChange"
          >
            <template #expand="{ row, index }">
              <slot name="expand" :row="row" :index="index" />
            </template>
            <template v-for="slotCol in tableSlots" #[colSlotName(slotCol)]="{ row, index }">
              <slot :name="slotCol.slotName" :row="row" :index="index" />
            </template>
          </gjw-table>
        </slot>
      </template>
    </gjw-list-page-layout>
  </div>
</template>

<script>
import GjwListPageLayout from '../../gjwListPageLayout/src/GjwListPageLayout.vue'
import GjwTable from '../../gjwTable/src/GjwTable.vue'
import GjwSearchForm from '../../gjwSearchForm/src/GjwSearchForm.vue'
export default {
  name: 'GjwListPage',
  components: {
    GjwListPageLayout,
    GjwSearchForm,
    GjwTable,
  },
  props: {
    pageConfig: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      queryData: {},
      singleButtons: [],
      groupButtons: [],
      showRefreshIcon: false,
      searchFormProps: {},
      tableProps: {},
      tableColumns: [],
      selectList: [],
      dataTotal: 0,
    }
  },
  computed: {
    colSlotName() {
      return (col) => col.slotName
    },
    tableSlots() {
      return this.tableColumns.filter((col) => col.type === 'slot')
    },
  },
  watch: {
    'pageConfig.searchForm': {
      handler(newVal) {
        this.searchFormProps = newVal
      },
      immediate: true,
    },
    'pageConfig.buttonArea': {
      handler(newVal) {
        this.singleButtons = newVal.singleButtons || []
        this.groupButtons = newVal.groupButtons || []
        this.showRefreshIcon = newVal.showRefreshIcon
      },
      immediate: true,
    },
    'pageConfig.table': {
      handler(newVal) {
        this.tableColumns = newVal.columns || []
        this.dataTotal = newVal.totalCount || 0
        this.tableProps = newVal
      },
      immediate: true,
    },
  },
  methods: {
    resetSearch() {
      this.$refs.gjwSearchForm.reset()
    },
    getTableData(query) {
      this.queryData = query
      this.$refs.gjwTable.getList(query)
    },
    refreshTableData(query) {
      this.queryData = query
      this.$refs.gjwTable.refresh(query)
    },
    editRow(row, index) {
      this.$refs.gjwTable.editRow(row, index)
    },
    handleListChange(list, total) {
      this.dataTotal = total
    },
    handleSelectChange(selection) {
      this.selectList = selection
    },
    handleRefreshList() {
      this.$refs.gjwTable.getList(this.queryData)
      this.$emit('click-refresh')
    },
  },
}
</script>

<style scoped>
.gjw-list-page{
  height: 100%;
}
.left-buttons{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.group-btns{
  margin-left: 10px;
}
.refresh-btn{
  font-size: 16px;
  margin-left: 10px;
}
</style>
